import { type ConsentType } from "@repo/api";
import { t } from "@repo/translation";

export const getConsentDescription = (consentTypes: ConsentType[]) => {
  // No message for promotion
  if (
    consentTypes.length === 1 &&
    consentTypes.includes("PROMOTIONAL_CONSENT")
  ) {
    return {
      desc_1: undefined,
      desc_2: undefined,
    };
  } else {
    return {
      desc_1: t("customer_consent.description1"),
      desc_2: t("customer_consent.description2"),
    };
  }
};
